module.exports = __webpack_public_path__ + "static/media/fightscout-news-mobile-new.edb398b7.png";